import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { sanitizeRichHtml } from "./sanitizeRichHtml.js";
/**
 * Inline editable text. Abstracted from the Alamir Auto `EditableField`: instead of
 * `content[contentKey]` + `setContent`, it takes a `value` and an `onCommit`, so any
 * ViewModel command can back it. Never renders an input unless `editable` is true.
 */
export function EditableField({ value, onCommit, editable = false, label, as: Tag = "p", multiline = false, richText = false, placeholder, prefix, suffix, inputMode, className, rows, keepEmpty = false, editClassName, }) {
    const [draft, setDraft] = useState(value);
    useEffect(() => setDraft(value), [value]);
    const commit = () => {
        if (draft !== value)
            onCommit(draft);
    };
    if (editable) {
        const common = {
            className: editClassName ?? ["lumora-editable", className].filter(Boolean).join(" "),
            "aria-label": label,
            "data-lumora-editable": "true",
            value: draft,
            placeholder: placeholder ?? label,
            onBlur: commit,
        };
        if (multiline || richText) {
            return (_jsx("textarea", { ...common, rows: rows ?? (richText ? 6 : 4), onChange: (e) => setDraft(e.target.value) }));
        }
        return (_jsx("input", { ...common, type: "text", ...(inputMode ? { inputMode } : {}), onChange: (e) => setDraft(e.target.value), onKeyDown: (e) => {
                if (e.key === "Enter")
                    e.target.blur();
            } }));
    }
    if (!keepEmpty && !value.trim())
        return null;
    if (richText) {
        return (_jsx(Tag, { className: className, "data-lumora-rich": "true", dangerouslySetInnerHTML: { __html: sanitizeRichHtml(value) } }));
    }
    return (_jsxs(Tag, { className: className, children: [prefix, value, suffix ? ` ${suffix.trim()}` : ""] }));
}
//# sourceMappingURL=EditableField.js.map